<template>
  <form @submit.prevent>
    <h6 class="heading-small text-muted mb-4">Export Lineups</h6>
    <!-- Add explanation text -->
    <div class="alert alert-info text-sm mb-4">
      <i class="fas fa-info-circle mr-2"></i>
      Enter your email below. The file will be sent to the provided address.
    </div>

    <!-- Email input -->
    <div class="form-group">
      <label class="form-control-label">Email</label>
      <base-input
        v-model="model.email"
        type="email"
        placeholder="your@email.com"
        :class="{'is-invalid': errors.email}"
        required
      />
      <small v-if="errors.email" class="text-danger">{{ errors.email[0] }}</small>
    </div>

    <!-- Submit button -->
    <div class="text-right">
      <base-button
        type="submit"
        class="submit"
        @click="submit"
        :loading="loading"
          :disabled="loading"
      >
      <span v-if="loading">
        <i class="fa fa-spinner fa-spin" v-if="loading"></i> Sending...
      </span>

      <span v-else>
        <i class="fas fa-paper-plane mr-2"></i>
        Send
        </span>
      </base-button>
    </div>
  </form>
</template>
<script>
  import Service from "@/services/Lineups";
  export default {
    name: "export-lineups",
    props: {
      type: {
        default: "terminal",
      },
      params: {
        type: Object,
        default: () => {},
      },
      portos: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        errors: {},
        loading: false,
        
        model: {
          email: "",
          
        },
      };
    },
    created() {
   
    },
    methods: {
    
      submit() {
        this.loading = true;
        this.errors = {};
        Service
          .sendToEmail({  ...this.params, ...this.model, type: this.type })
          .then((response) => {
            this.loading = false;
            this.$notify({
              type: "success",
              message: "Sent successfully!",
              horizontalAlign: "center",
            });
            this.$emit("close");
          })
          .catch((err) => {
            this.loading = false;
            if (err.response && err.response.data && err.response.data.errors) {
              let errors = err.response.data.errors;
              this.errors = errors;
              this.$notify({
                type: "danger",
                message: "Please check the form",
                horizontalAlign: "center",
              });
            }
          });
      },
    },
  };
</script>
